import { InputBase, useMediaQuery } from "@mui/material";
import styled from "styled-components";

export const styleInput = {
  paddingLeft: "10px",
  paddingRight: "10px",
};

const commonStyleLabel = {
  textAlign: "right",
};

export const desktopStyleLabel = {
  fontSize: "12px",
};

export const mobileStyleLabel = {
  fontSize: "10px",
};

const regularStyleLabel = {};

const errorStyleLabel = {
  color: "var(--emr-red)",
};

export const styleLabel = {
  ...commonStyleLabel,
  ...desktopStyleLabel,
  ...regularStyleLabel,
};

export const styleLabelWithError = {
  ...commonStyleLabel,
  ...desktopStyleLabel,
  ...errorStyleLabel,
};

export const phoneStyleLabel = {
  ...commonStyleLabel,
  ...mobileStyleLabel,
  ...regularStyleLabel,
};

export const phoneStyleLabelWithError = {
  ...commonStyleLabel,
  ...mobileStyleLabel,
  ...errorStyleLabel,
};

export const StyleAsarInput = styled(InputBase)(() => ({
  border: "solid 1px var(--emr-borderInput)",
  borderRadius: "8px",
  boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
  "& .MuiInputBase-input": styleInput,
  "&.Mui-error": {
    borderColor: "red",
    boxShadow: "0 0 0 1px var(--emr-red)",
  },
  // مخفی کردن آیکون پیش‌فرض مرورگر در Edge/Chrome
  '& input[type="password"]::-ms-reveal': {
    display: "none",
  },
  '& input[type="password"]::-ms-clear': {
    display: "none",
  },
  // برای Chrome, Safari, جدیدترها
  '& input[type="password"]::-webkit-contacts-auto-fill-button': {
    visibility: "hidden",
    display: "none",
    pointerEvents: "none",
    position: "absolute",
    right: 0,
  },
}));

function StyleAsarInputComponent(props) {
  const md = useMediaQuery("(max-width:450px)");
  let sx = { ...{ width: "100%" }, ...(props.style ?? {}) };
  if (md) {
    sx = {
      ...sx,
      ...{
        "& .MuiInputBase-input": {
          fontSize: "10px",
          padding: "9px",
        },
      },
    };
  }

  return <StyleAsarInput sx={sx} {...props} />;
}

export default StyleAsarInputComponent;
